import posthog from "posthog-js"
import { z } from "zod"

const MAX_ISSUES = 10

const reported = new Set<string>()

export function captureContractMismatch(
	scope: "ws.contract" | "http.contract",
	title: string,
	issues: readonly z.core.$ZodIssue[],
	properties: Record<string, unknown>,
): void {
	const details = z.prettifyError({ issues: issues.slice(0, MAX_ISSUES) })
	const key = `${title}|${details}`
	if (reported.has(key)) return
	reported.add(key)

	console.warn(`[${scope}] ${title}\n${details}`)
	posthog.captureException(new Error(`${title}\n${details}`), {
		...properties,
		scope,
		issues: details,
		$exception_fingerprint: title,
	})
}
